import BaseService from "./BaseService";

export default class FileUploadService extends BaseService {

  constructor() {
    super('docs')
  }

  async getFileUploadUrl() {
    await this.retrieveBackendUrl()
    return this.backendUrl
  }

}
